module.exports = __webpack_public_path__ + "img/f67d88a87fed31df29301a8869f8f04c.png";